/** @format */

import React, { Suspense, useMemo } from "react";
import { staticCardTypes } from "../contentEditor/utils";
import { ErrorBoundary } from "../errorBoundary/ErrorBoundary";
import { Card, CardObject } from "../resources/types";

type ActivityAnswersProps = {
  card: Card;
  id: string;
};
const ActivityAnswers: React.FC<ActivityAnswersProps> = ({ card, id }) => {
  const activity: CardObject = card.Object;
  const type = activity.type;
  // const Empty:React.FC<CardComponentProps> = () => null

  //console.log(type)
  const Answers = useMemo(() => {
    // if(type !== 'read') return Empty
    const _type = type.charAt(0).toUpperCase() + type.slice(1);
    const _staticCardTypes = staticCardTypes.filter(
      (type) => !["gallery", "carousel"].includes(type.id),
    );
    if (_staticCardTypes.find((_type) => type === _type.id)) {
      return React.lazy(
        () => import(`./cards/NoAnswers`), // UPDATE PATH
      );
    } else {
      return React.lazy(
        () => import(`./cards/${_type}Card/${_type}Answers`), // UPDATE PATH
      );
    }
  }, [type]);

  return (
    <ErrorBoundary>
      <Suspense fallback={<div role="status"></div>}>
        <Answers card={activity} id={id} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default ActivityAnswers;
